<div class="container mt2 aqx-message-container">
  <div class="row">
    <div class="col-sm-6 offset-sm-3">
      <div *ngFor="let message of messageService.messages">
        <div id="{{message.id}}}"
             class="alert {{message.type.class}} alert-dismissible"
             role="alert">
          <button class="close"
                  type="button"
                  aria-label="Close"
                  (click)="messageService.remove(message)">
            <small area-hidden="true">&times;</small>
          </button>
          <i class="{{message.type.classImage}}"></i>
          {{message.text}}
        </div>
      </div>
    </div>
  </div>
</div>
